<template>
  <div class="group-filter-bg px-md-4 py-md-4">
    <div class="row pt-0 mr-lg-4 justify-content-between">
      <div :class="`col-sm-6 col-xl-3`">
        <div class="form-group">
          <input v-model.trim="firstName" id="firstNameVacataire" name="firstNameVacataire" type="text" autofocus
            placeholder="Prénom" class="form-control" />
        </div>
      </div>
      <div :class="`col-sm-6 col-xl-3`">
        <div class="form-group">
          <input v-model.trim="lastName" id="lastNameVacataire" name="lastNameVacataire" type="text" autofocus
            placeholder="Nom" class="form-control" />
        </div>
      </div>
      <div :class="`col-sm-6 col-xl-3`">
        <div class="form-group group-filter">
          <select class="form-control" v-model="typeOfContracts">
            <option value="">Type de contrat</option>
            <option v-for="(status, index) in contractTypeList" :value="status" :key="index">
              {{ contractType[status].name }}
            </option>
          </select>
          <div class="select-down">
            <img class="select-down__icon" src="@/assets/images/down-arrow.svg" alt="Arrow Icon" aria-hidden="true" />
          </div>
        </div>
      </div>
      <!-- Apply Button -->
      <div :class="`only-desk-top col-sm-6 col-xl-3 mb-3 mb-md-0 d-flex`">
        <div class="task-manager-apply" style="margin-left: 5px">
          <button class="btn btn-primary" @click="saveSearch()">
            {{ $t("global.apply") }}
          </button>
        </div>
        <div class="task-manager-apply" style="margin-left: 5px">
          <button class="btn btn-primary" @click="refresh()">
            {{ $t("global.reset") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fr } from "vuejs-datepicker/dist/locale";
import contractType from "../../data/contract/contractType";

export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      type: "",
      contractType,
      contractTypeList: Object.keys(contractType),
      fr,
      firstName: "",
      lastName: "",
      typeOfContracts: "",
    };
  },
  mounted() {
    this.$services.structure.findAll().then((response) => {
      this.structureList = response.data;
    });
  },
  watch: {
    startDate(newv, old) {
      this.startDate = newv === null ? old : newv;
    },
    endDate(newv, old) {
      this.endDate = newv === null ? old : newv;
    },
  },
  methods: {
    saveSearch() {
      const obj = {};
      if (this.firstName) {
        obj.firstName = this.firstName;
      }
      if (this.lastName) {
        obj.lastName = this.lastName;
      }
      if (this.typeOfContracts) {
        obj.typeOfContracts = this.typeOfContracts;
      }

      this.$store.dispatch("setFilter", obj);
      this.$root.$emit("searchRequests", obj);
    },

    refresh() {
      this.firstName = "";
      this.lastName = "";
      this.typeOfContracts = "";
      this.saveSearch();
    },
  },
};
</script>

<style lang="scss"></style>
